import Layout from 'Nori/Layout';
import HeroQuestion from 'Custom/HeroQuestion/index';
import Carousel from 'Custom/Carousel';

import styles from 'styles/pages/fiveFastFacts.module.scss';

import { CARDS_CAROUSEL } from 'Utils/five-fast-facts';

const HEAD = {
  title:
    'Five Fast Facts About NEXPLANON® (etonogestrel implant) 68 mg Radiopaque',
  description:
    'Find out more information about NEXPLANON® (etonogestrel implant) 68 mg Radiopaque with 5 quick facts.',
  keywords: 'Nexplanon Implant Details, Nexplanon Information, Nexplanon Facts',
};

export default function Home() {
  return (
    <Layout head={HEAD}>
      <section className={styles.fivefactsCarousel}>
        <Carousel
          data-qa-tag="five-facts-carousal-section"
          items={CARDS_CAROUSEL}
          data-design-visible="visible_vd"
          data-design-type="module"
          data-design-nori_id="Carousel"
          data-design-module_name="GET TO KNOW NEXPLANON"
          data-design-module_no="01"
        /></section>
      <HeroQuestion data-qa-tag="five-facts-heroQUestion-section"></HeroQuestion>
    </Layout>
  );
}
